import { useEffect, useState } from "react";
import axios from "axios";
import useResetTimeout from "../useResetTimeout";
import { OrderSummary } from "../../containers/OrderHistoryContainer/types";
import useErrorHandler from "../userErrorHandler";

const useOrderById = (id: number, orderType: string, dependencies?: any[]) => {
  const resetTimeout = useResetTimeout();
  const setError = useErrorHandler();
  const [order, setOrder] = useState<OrderSummary>({} as OrderSummary);
  const [orderLoading, setOrderLoading] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        if (
          typeof id !== "undefined" &&
          id !== null &&
          typeof orderType !== "undefined" &&
          orderType !== null
        ) {
          setOrderLoading(true);
          const path =
            (orderType === "Order"
              ? `/api/Orders/${id}?ts=`
              : `/api/Orders/currency-returns/${id}?ts=`) +
            new Date().getTime();
          const response = await axios.get(path);
          setOrder(response.data as OrderSummary);
          setOrderLoading(false);
          resetTimeout();
        }
      } catch (err) {
        if (err.message === "Network Error") {
          document.location.href = "/";
        }
        setOrderLoading(false);
        setError("Unable to read order " + id, err);
      }
    })();
  }, dependencies);

  return { order, orderLoading };
};
export default useOrderById;
